import Socket from '../../redux/socketConnect';
import ForceLogoutModal from '../ForceLogoutModal';
import Swal from 'sweetalert2';

export const forceLogout =  (message, deviceName) => {
    sessionStorage.removeItem("userLoggedDetails");
    sessionStorage.removeItem("userLoggedToken");
    sessionStorage.clear();
    localStorage.clear();

    alert([
        'New Device Login Detected',
        '',
        message
          ? message
          : 'Your account was logged in on another device.'
      ].join('\n'));
};

// Shows a SweetAlert2 modal then immediately navigates back to the previous
// page (before the business portal). Used for USER_NOT_FOUND and session-expired
// events that originate from the business web-view portal.
export const showPortalErrorAndRedirect = (title, message) => {
  Swal.fire({
    title,
    text: message,
    icon: 'error',
    confirmButtonText: 'OK',
    confirmButtonColor: '#d32f2f',
    allowOutsideClick: false,
    allowEscapeKey: false,
  }).then(async () => {
    sessionStorage.removeItem('businessToken');
    sessionStorage.removeItem('businessRefreshToken');
    sessionStorage.removeItem('businessUserDetails');
    const { default: store } = await import('../../redux/store');
    const { logoutBusinessLocal } = await import('../../redux/businessAuthSlice');
    store.dispatch(logoutBusinessLocal());
    window.location.href = '/';
  });
};

